import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ClubInfo } from 'src/data/club-course';
import {
  ClubData,
  ClubMembershipExtended,
  ClubMembershipOption,
  ClubMembershipType,
  Country,
  EInvoicingEntityForm,
  PlayerData,
  PlayerInfo,
  initEInvoicingEntityForm,
} from 'src/data/mygolf.data';
import { getDistanceInKM } from 'src/globals';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { ClubService } from 'src/providers/club-service/club-service';
import { GeolocationService } from 'src/providers/geolocation-service/geolocation-service';
import { CommonPullupMenuComponent } from '../../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { CountryListPage } from '../../modal-screens/country-list/country-list.page';
import { PlayerService } from 'src/providers/player-service/player-service';
import { key } from 'localforage';

@Component({
  selector: 'app-tax-einvoicing-info',
  templateUrl: './tax-einvoicing-info.page.html',
  styleUrls: ['./tax-einvoicing-info.page.scss'],
})
export class TaxEinvoicingInfoPage implements OnInit {
  public refresher: any;
  public infinite: any;
  public searchQuery: string = '';

  public recentClubs: Array<ClubInfo>;
  public nearByClubs: Array<ClubInfo>;

  clubInfo: ClubData; //ClubInfo;
  player$: Observable<PlayerInfo>;

  clubMembershipTypes: Array<ClubMembershipType>;

  selMembershipType: ClubMembershipType = null;
  clubMembershipOption: ClubMembershipOption;
  enableStatementEmail: boolean = false;
  correspondenceEmail: string;
  setHomeClub: boolean = false;
  joinedOn: string;
  validUntil: string;
  editMode: boolean = false;
  @Input() clubMembership: ClubMembershipExtended;
  membershipNo: string;

  modalMode: boolean = true;
  fromClub: boolean = false;
  selectedMembershipType: string = 'FULL';
  maxDate: string;

  nricNo: string;
  passportNo: string;
  legalName: string;
  incomeTaxNo: string;
  phoneNo: string;
  eInvoiceType: string = 'individual';
  tourismNo: string = '';
  sstNo: string = '';
  businessName: string = '';
  businessROCNo: string = '';
  businessAddress: string = '';
  shippingAddress: string = '';
  address1: string = '';
  address2: string = '';
  city: string = '';
  state: string = '';
  postalCode: string = '';
  phoneNumbers: string = '';
  country: string = '';
  taxIdentificationNumber: string = '';

  @ViewChild('imgUpload')
  imgUpload: ElementRef;

  company: EInvoicingEntityForm;
  individual: EInvoicingEntityForm;

  @Input() playerData: PlayerData;
  constructor(
    private router: Router,
    private navParams: NavParams,
    private modalCtl: ModalController,
    private flightService: ClubFlightService,
    private geo: GeolocationService,
    private loadingCtl: LoadingController,
    private clubService: ClubService,
    private platform: Platform,
    private toastCtl: ToastController,
    private nav: NavController,
    private alertCtl: AlertController,
    private mg2uUtils: mygolfUtils,
    private playerService: PlayerService
  ) {
    this.recentClubs = new Array<ClubInfo>();
    this.nearByClubs = new Array<ClubInfo>();

    this.company = initEInvoicingEntityForm();
    this.individual = initEInvoicingEntityForm();

    if (this.router.getCurrentNavigation()) {
      this.player$ = this.router.getCurrentNavigation().extras.state.player;
      this.clubInfo = this.router.getCurrentNavigation().extras.state.clubInfo;
      this.editMode = this.router.getCurrentNavigation().extras.state.editMode;
      this.clubMembership = this.router.getCurrentNavigation().extras.state.clubMembership;
      this.fromClub = this.router.getCurrentNavigation().extras.state.fromClub;
      this.playerData = this.router.getCurrentNavigation().extras.state.playerData;
    } else {
      this.player$ = navParams.get('player');
      this.clubInfo = navParams.get('clubInfo');
      this.editMode = navParams.get('editMode');
      this.clubMembership = navParams.get('clubMembership');
      this.fromClub = navParams.get('fromClub');
      this.playerData = navParams.get('playerData');
    }

    console.debug('this.player$', this.player$, navParams.get('player'));

    this.validUntil = moment().format('YYYY-MM-DD');
    this.joinedOn = moment().format('YYYY-MM-DD');
    this.maxDate = moment().add(30, 'y').format('YYYY-MM-DD');

    if (this.editMode) {
      // this.getListClubMembershipTypes(this.clubMembership.club.id);
      // this.getClubMembershipOptions(this.clubMembership.club.id);
      this.validUntil = moment(this.clubMembership.validUntil).format('YYYY-MM-DD');
      this.joinedOn = moment(this.clubMembership.joinedOn).format('YYYY-MM-DD');
      this.correspondenceEmail = this.clubMembership.correspondenceEmail;
      this.membershipNo = this.clubMembership.membershipNo;
      this.setHomeClub = this.clubMembership.playerHomeClub;
      this.selectedMembershipType = this.clubMembership.membershipType.typeId;
      this.nricNo = this.clubMembership.icNumber;
      this.passportNo = this.clubMembership.passport;
      this.legalName = this.clubMembership.legalName;
      this.incomeTaxNo = this.clubMembership.incomeTaxNumber;
      this.phoneNo = this.clubMembership.phoneNumber;
      this.enableStatementEmail = this.clubMembership.statementEmail;
      this.businessName = this.clubMembership?.einvoicingEntity?.name;
      this.businessROCNo = this.clubMembership?.einvoicingEntity?.businessRegistrationNumber;
      this.sstNo = this.clubMembership?.einvoicingEntity?.sst;
      this.tourismNo = this.clubMembership?.einvoicingEntity?.tourismNumber;
      this.address1 = this.clubMembership?.einvoicingEntity?.address?.address1;
      this.address2 = this.clubMembership?.einvoicingEntity?.address?.address2;
      this.city = this.clubMembership?.einvoicingEntity?.address?.city;
      this.state = this.clubMembership?.einvoicingEntity?.address?.state;
      this.postalCode = this.clubMembership?.einvoicingEntity?.address?.postCode;
      this.phoneNumbers =
        this.clubMembership?.einvoicingEntity?.address?.phoneNumbers?.numbers.join(',');
      this.eInvoiceType = this.clubMembership?.einvoicingOption.toLowerCase();
      this.taxIdentificationNumber = this.clubMembership?.einvoicingEntity?.taxIdentificationNumber;
      this.incomeTaxNo = this.clubMembership?.einvoicingEntity?.taxIdentificationNumber;
      this.country =
        this.clubMembership?.einvoicingEntity?.address?.countryData?.id ||
        this.clubMembership?.einvoicingEntity?.country?.id;
    } else {
      let _clubId = this.clubInfo?.clubId || this.clubInfo?.id;
      // this.getListClubMembershipTypes(_clubId);
      // this.getClubMembershipOptions(_clubId);
    }

    this.populateEInvoiceInfo();
  }

  ngOnInit() {
    // this._refreshValues();
    if (this.editMode) {
      // this.selMembershipType = this.clubMembership.membershipType;
    }
    this.getCountry();
  }

  getCountry() {
    this.playerService.getCountryList().subscribe((data: Array<Country>) => {
      this.countryList = data;
    }),
      error => {},
      () => {};
  }

  onSearchInput(searchbar) {
    this._refreshValues();
  }

  /**
   * Gets the distance between a current location and club in KMs
   * @param club The club information
   * @returns {number} Returns the distance in KM if GPS locations of current and club are available
   * else returns 0;
   */
  clubDistance(club: ClubInfo): string {
    let lat1 = this.geo.getLatitude();
    let lon1 = this.geo.getLongitude();
    if (lat1 != null && lon1 != null && club.latitude != null && club.longitude != null)
      return getDistanceInKM(lat1, lon1, club.latitude, club.longitude) + ' KM';
    return '';
  }

  /**
   * Executed when refresh button on toolbar is clicked
   */
  onRefreshClick(refresher) {
    this.refresher = refresher;
    this._refreshValues();
  }

  clubSelected(event, item: ClubInfo) {
    // this.events.publish("clubSelected", item);
    this.clubMembershipNumberPrompt();
  }

  private async _refreshValues() {}

  async clubMembershipNumberPrompt() {
    let prompt = await this.alertCtl.create({
      header: 'Club Membership',
      message: 'Enter your club Membership Number',
      inputs: [
        {
          name: 'membershipNumber',
          placeholder: 'Membership Number',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
          },
        },
        {
          text: 'Save',
          handler: data => {
            this.nav.pop();
          },
        },
      ],
    });
    prompt.present();
  }

  getPlayerDetails(attribute?: string) {
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
    });
    switch (attribute) {
      case 'name':
        return _player.playerName;
    }
  }

  getClubDetails(attribute?: string) {
    let _clubInfo: ClubData;
    let _clubName;
    if (!this.editMode) _clubInfo = this.clubInfo;
    else if (this.editMode) _clubName = this.clubMembership.club.name;

    switch (attribute) {
      case 'name':
        if (this.editMode) return _clubName;
        else return _clubInfo.clubName || _clubInfo.name;
    }
  }

  getListClubMembershipTypes(clubId: number) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    this.flightService.getListClubMembershipTypes(_params).subscribe(
      (data: Array<ClubMembershipType>) => {
        if (data && data.length > 0) {
          console.debug('club membership types : ', data);
          this.clubMembershipTypes = data;

          // this.selMembershipType =
          this.clubMembershipTypes
            .filter((type: ClubMembershipType) => {
              return type.typeId === 'FULL';
            })
            .map((type: ClubMembershipType) => {
              // this.selMembershipType = JSON.parse(JSON.stringify(type));
              this.selectedMembershipType = type.typeId;
              this.selMembershipType = type;
            });
        } else if (!this.editMode) {
          if (!this.clubMembershipTypes) this.clubMembershipTypes = [];
          this.clubMembershipTypes.push({
            typeId: 'FULL',
            typeName: 'Full Membership',
          });
          // this.selMembershipType = JSON.parse(JSON.stringify(this.clubMembershipTypes[0]));
          this.selectedMembershipType = this.clubMembershipTypes[0].typeId;

          this.clubMembershipTypes
            .filter((type: ClubMembershipType) => {
              return type.typeId === 'FULL';
            })
            .map((type: ClubMembershipType) => {
              // this.selMembershipType = JSON.parse(JSON.stringify(type));
              this.selectedMembershipType = type.typeId;
            });

          let _msg = 'This club currently have no Club Membership Types defined';
          MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');

          this.modalCtl.dismiss(false);
          return false;
        }
        if (this.editMode && this.clubMembership) {
          // this.selMembershipType = JSON.parse(JSON.stringify(this.clubMembership.membershipType));
          this.selectedMembershipType = this.clubMembership.membershipType.typeId;
        }
      },
      error => {
        let _msg = 'This club currently have no Club Membership Types defined';
        MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
        this.modalCtl.dismiss(false);
        return false;
      }
    );
  }

  getClubMembershipOptions(clubId: number) {
    let _clubId = clubId;
    this.flightService.getClubMembershipOptions(_clubId).subscribe((data: ClubMembershipOption) => {
      if (data) {
        console.debug('club membership types : ', data);
        this.clubMembershipOption = data;
      }
    });
  }

  onSaveClubMembership() {
    // if (!this.membershipNo || this.membershipNo.length === 0) {
    //   MessageDisplayUtil.showMessageToast('Please specify Membership Number',
    //     this.platform, this.toastCtl, 3000, "bottom")
    //   return false;
    // }
    // // if(!this.selMembershipType) {
    // if (!this.selectedMembershipType) {
    //   MessageDisplayUtil.showMessageToast('Please specify the membership type',
    //     this.platform, this.toastCtl, 3000, "bottom")
    //   return false;
    // }
    // let _joinedOn = moment(this.joinedOn, "YYYY-MM-DD").toDate();
    // let _validUntil = moment(this.validUntil, "YYYY-MM-DD").toDate();
    // if (this.selectedMembershipType.toLowerCase() !== 'full' && (_joinedOn >= _validUntil)) {
    //   console.debug("save club membership : ", this.selectedMembershipType, _joinedOn, _validUntil)
    //   MessageDisplayUtil.showMessageToast('Please specify valid dates for Joined On and Valid Until',
    //     this.platform, this.toastCtl, 3000, "bottom")
    //   return false;
    // }
    // if (this.enableStatementEmail && (this.correspondenceEmail && this.correspondenceEmail.length === 0 || !this.correspondenceEmail)) {
    //   MessageDisplayUtil.showMessageToast('Please specify the email address',
    //     this.platform, this.toastCtl, 3000, "bottom")
    //   return false;
    // }
    // this.goSaveClubMembership();
  }
  goSaveClubMembership() {
    let _clubId;
    if (this.editMode) {
      _clubId = this.clubMembership.club.id;
    } else {
      _clubId = this.clubInfo?.clubId || this.clubInfo?.id;
    }
    let _player: PlayerInfo;
    let _playerId;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
      _playerId = player.playerId ? player.playerId : player.id;
    });

    if (this.selectedMembershipType === 'FULL') this.validUntil = '2999-12-31';
    let _params;
    _params = {
      membershipNo: this.membershipNo,
      membershipType: this.selectedMembershipType,
      joinedOn: this.joinedOn,
      validUntil: this.validUntil,
      statementEmail: this.enableStatementEmail,
      correspondenceEmail: this.correspondenceEmail,
      homeClub: this.setHomeClub,
      icNumber: this.nricNo,
      passport: this.passportNo,
      legalName: this.legalName,
      incomeTaxNumber: this.incomeTaxNo,
      phoneNumber: this.phoneNo,
      individual: this.eInvoiceType === 'individual' ? true : false,
      companyName: this.businessName || '',
      businessRegistrationNumber: this.businessROCNo || '',
      sst: this.sstNo || '',
      tourismNumber: this.tourismNo || '',
      address1: this.address1 || '',
      address2: this.address2 || '',
      city: this.city || '',
      state: this.state || '',
      postalCode: this.postalCode || '',
      phoneNumbers: this.phoneNumbers?.split(',') || '',
      einvoicingOption: this.mg2uUtils.capitalizeFirstLetter(this.eInvoiceType),
      country: this.country || '',
    };
    let image = this.selectedFiles;
    this.flightService.createUpdatePrimaryMembership(_clubId, _playerId, _params, image).subscribe(
      (clubMembership: ClubMembershipExtended) => {
        if (clubMembership) {
          console.debug('save club membership : ', clubMembership);
          if (!this.fromClub)
            MessageDisplayUtil.showMessageToast(
              'Successfully added club as membership. Please contact club for approval.',
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );

          this.modalCtl.dismiss(clubMembership);
          return false;
        }
      },
      async error => {
        let _error = error.json();
        let _title = 'Add Membership Failed';
        let _msg = _error.errorMessage;

        let prompt = await this.alertCtl.create({
          header: _title,
          cssClass: 'booking-error',
          message: _msg,
          buttons: [
            {
              text: 'Ok',
              handler: data => {},
            },
          ],
        });
        prompt.present();
        return false;
      }
    );
  }

  onClose() {
    this.modalCtl.dismiss();
  }

  onChangeMembershipType() {
    console.debug(
      'on change membership type ',
      this.selMembershipType,
      this.selectedMembershipType
    );
    // if(!this.selMembershipType) return;
    // let _selectedType;
    this.clubMembershipTypes
      .filter(type => {
        return type.typeId === this.selectedMembershipType;
      })
      .map(type => {
        this.selMembershipType = type;
        if (!this.selMembershipType.termMembership) {
          this.validUntil = '2999-12-31';
        } else if (this.selMembershipType.termMembership) {
          this.validUntil = moment().add(1, 'y').format('YYYY-MM-DD');
        }
      });
  }

  async onClickMembershipType() {
    console.debug('in click membership type : ', this.clubMembershipTypes);
    if (!this.clubMembershipTypes) return;
    if (this.editMode && this.clubMembership.active && this.clubMembership?.membershipType) return;

    let _dataList = [];
    if (this.clubMembershipTypes?.length > 0) {
      this.clubMembershipTypes.forEach(type => {
        _dataList.push({
          id: type.typeId,
          name: type.typeName,
        });
      });
    }

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data?.data) {
        this.selectedMembershipType = this.clubMembershipTypes.find((type: ClubMembershipType) => {
          return type.typeId === data.data.id;
        }).typeId;
        this.selMembershipType = this.clubMembershipTypes.find((type: ClubMembershipType) => {
          return type.typeId === data.data.id;
        });
        this.onChangeMembershipType();
      }
      // if(data)
    });
  }

  getSelectedTypeInfo(attribute: string) {
    if (this.selectedMembershipType) return '';
    let _typeInfo = this.clubMembershipTypes.find((type: ClubMembershipType) => {
      return type.typeId === this.selectedMembershipType;
    });
    switch (attribute) {
      case 'name':
        return _typeInfo.typeName;
      case 'id':
        return _typeInfo.typeId;
    }
  }

  selectedFiles: any;
  temporaryImageURL: string;
  previewImage: any;
  async takePhotoFromGallery(event, mode?: string) {
    // if (event) {
    //   const fileObject = event.target.files[0];
    // }

    this.selectedFiles = event.target.files[0];
    // const file = (event.target as HTMLInputElement).files;
    //

    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      const images = [];
      for (let i = 0; i < filesAmount; i++) {
        const reader = new FileReader();
        // eslint-disable-next-line @typescript-eslint/no-shadow
        reader.onload = (event: any) => {
          // Push Base64 string
          images.push(event.target.result);
        };
        reader.readAsDataURL(event.target.files[i]);
      }
      this.temporaryImageURL = event.target.files[0].name;
      this.previewImage = images;

      // if (this.selectedFiles && mode === 'update')
      //   this._uploadImage(this.temporaryImageURL);
    }
  }

  deleteImage() {
    this.selectedFiles = null;
    this.temporaryImageURL = null;
    // if(this.playerDiscountProgram?.document){
    //    this.playerDiscountProgram.document = null;
    // }
  }

  getMemberImage() {
    if (this.clubMembership?.memberImage) return this.clubMembership.memberImage;
    // else if(this.previewImage) return this.previewImage
    else return this.temporaryImageURL;
  }

  getCountryInfo(countryId, type: string) {
    if (!this.countryList) return;
    if (!this.country && type === 'country') {
      return 'Tap here to select';
    }
    let _country;
    this.countryList
      .filter(c => {
        if (type === 'country') return c.id === this.country || c.id === countryId;
      })
      .map(c => {
        _country = c;
      });
    return _country?.name;
  }
  countryList: Array<any>;
  async onSelectCountry(type: string) {
    let modal = await this.modalCtl.create({
      component: CountryListPage,
      componentProps: {
        country: this.countryList,
        headerName:
          this.eInvoiceType === 'individual'
            ? 'Select Residing In'
            : 'Select Origin Company Country',
        excludeAll: true,
      },
    });
    modal.onDidDismiss().then((country?: any) => {
      console.debug('selected country : ', type, country, this.country);
      if (country?.data) {
        let _country: Country = country.data;
        if (this.eInvoiceType === 'individual') {
          this.individual.country = _country.id;
        } else if (type === 'country') {
          this.company.country = _country.id;
          this.country = _country.id;
        }
      }
    });
    modal.present();
  }

  toggleInvoiceType(data: string) {
    if (!data) return;
    this.eInvoiceType = data;
  }

  getFlagUrl() {}

  getDocumentType() {
    if (this.eInvoiceType === 'individual') {
      return this.individual?.idType;
    } else if (this.eInvoiceType === 'company') {
      return this.company?.idType;
    }
  }

  async onSelectDocumentType() {
    let _documentType = '';
    if (this.eInvoiceType === 'individual') {
      _documentType = this.individual?.idType;
    } else if (this.eInvoiceType === 'company') {
      _documentType = this.company?.idType;
    }

    let _dataList = [
      {
        id: 'NRIC',
        name: 'National Registration Identity Card',
        iconUrl: 'assets/icons/golf-website.png',
      },
      {
        id: 'PASSPORT',
        name: 'Passport Number',
        iconUrl: 'assets/icons/book.png',
      },
      {
        id: 'ARMY',
        name: 'Army Identification Card',
        iconUrl: 'assets/icons/golf-field.png',
      },
    ];
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
        headerTitle: 'Identification Document Type',
        selectedValue: _documentType,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      let _idType = '';
      if (data?.data) {
        _idType = data?.data?.id;
        if (this.eInvoiceType === 'individual') {
          this.individual.idType = _idType;
        } else if (this.eInvoiceType === 'company') {
          this.company.idType = _idType;
        }
      }
      // if(data)
    });
  }

  onSaveEInvoiceInfo() {
    if (this.eInvoiceType === 'individual') {
      if (!this.individual.idType) {
        MessageDisplayUtil.showMessageToast(
          'Please specify an Identification Type',
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
        return false;
      }
      if (!this.individual.idValue || this.individual?.idValue?.length === 0) {
        MessageDisplayUtil.showMessageToast(
          'Please specify an Identification Number',
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
        return false;
      }
    } else if (this.eInvoiceType === 'company') {
      if (!this.company?.businessRegistrationNumber) {
        MessageDisplayUtil.showMessageToast(
          'Please specify Company Registration Number',
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
        return false;
      }
    }
    this.goSaveEInvoiceInfo();
  }

  onValidateFields() {
    return new Promise((resolve, reject) => {});
  }

  goSaveEInvoiceInfo() {
    let _clubId;
    if (this.editMode) {
      _clubId = this.clubMembership.club.id;
    } else {
      _clubId = this.clubInfo?.clubId || this.clubInfo?.id;
    }
    let _player: PlayerData = this.playerData;

    if (this.selectedMembershipType === 'FULL') this.validUntil = '2999-12-31';
    // let _params;
    // _params = {
    //   membershipNo: this.membershipNo,
    //   membershipType: this.selectedMembershipType,
    //   joinedOn: this.joinedOn,
    //   validUntil: this.validUntil,
    //   statementEmail: this.enableStatementEmail,
    //   correspondenceEmail: this.correspondenceEmail,
    //   homeClub: this.setHomeClub,
    //   icNumber: this.nricNo,
    //   passport: this.passportNo,
    //   legalName: this.legalName,
    //   incomeTaxNumber: this.incomeTaxNo,
    //   phoneNumber: this.phoneNo,
    //   individual: this.eInvoiceType === 'individual'?true:false,
    //   companyName: this.businessName || '',
    //   businessRegistrationNumber: this.businessROCNo || '',
    //   sst: this.sstNo || '',
    //   tourismNumber: this.tourismNo || '',
    //   address1: this.address1 || '',
    //   address2: this.address2 || '',
    //   city: this.city || '',
    //   state: this.state || '',
    //   postalCode: this.postalCode || '',
    //   phoneNumbers: this.phoneNumbers?.split(',') || '',
    //   einvoicingOption: this.mg2uUtils.capitalizeFirstLetter(this.eInvoiceType),
    //   country: this.country || '',
    // }
    let _individualForm: EInvoicingEntityForm = initEInvoicingEntityForm();
    let _companyForm: EInvoicingEntityForm = initEInvoicingEntityForm();
    let _country = this.country || 'MYS';
    let _einvoicingOption = this.mg2uUtils.capitalizeFirstLetter(this.eInvoiceType);
    let _params = {
      eInvoicingOption: _einvoicingOption,
      // individual: _individualForm,
      // company: _companyForm,
      country: _country,
    };
    if (this.eInvoiceType === 'individual' || this.individual?.idType?.length > 0) {
      for (let key in this.individual) {
        if (this.individual[key]) _params[`individual.${key}`] = this.individual[key];
      }
      // _country = this.playerData?.address?.countryData?.id;
    }
    if (this.eInvoiceType === 'company' || this.company?.businessRegistrationNumber?.length > 0) {
      for (let key in this.company) {
        if (this.company[key]) _params[`company.${key}`] = this.company[key];
      }
      // _country = this.country;
    }

    // _params = Object.assign(_params, {
    //   individual: _individualForm,
    //   company: _companyForm
    // })
    console.debug('save e-invoice info : ', _params, _companyForm, _individualForm);
    this.flightService
      .updatePlayerEInvoiceInfo(
        _player?.playerId || _player?.id,
        _einvoicingOption,
        _country,
        _params
      )
      .subscribe(
        (player: PlayerData) => {
          if (player) {
            if (!this.fromClub)
              MessageDisplayUtil.showMessageToast(
                'Successfully saved e-invoice info.',
                this.platform,
                this.toastCtl,
                3000,
                'bottom'
              );

            this.modalCtl.dismiss(player);
            return false;
          }
        },
        async error => {
          let _error = error.json();
          let _title = 'Add Membership Failed';
          let _msg = _error.errorMessage;

          let prompt = await this.alertCtl.create({
            header: _title,
            cssClass: 'booking-error',
            message: _msg,
            buttons: [
              {
                text: 'Ok',
                handler: data => {},
              },
            ],
          });
          prompt.present();
          return false;
        }
      );
  }

  populateEInvoiceInfo() {
    console.debug('player data', this.playerData);
    if (this.playerData) {
      if (this.playerData?.einvoiceEntityIndividual) {
        this.individual.companyName = this.playerData?.einvoiceEntityIndividual?.name;
        this.individual.idType = this.playerData?.einvoiceEntityIndividual?.idType;
        this.individual.idValue = this.playerData?.einvoiceEntityIndividual?.idValue;
        this.individual.incomeTaxNumber =
          this.playerData?.einvoiceEntityIndividual?.taxIdentificationNumber;
        this.individual.address1 =
          this.playerData?.einvoiceEntityIndividual?.address?.address1 ||
          this.playerData?.addresses[0]?.address?.address1;
        this.individual.phoneNumbers =
          this.playerData?.einvoiceEntityIndividual?.address?.phoneNumbers?.numbers;
      }
      if (this.playerData?.einvoiceEntityCompany) {
        this.company.companyName = this.playerData?.einvoiceEntityCompany.name;
        this.company.businessRegistrationNumber =
          this.playerData?.einvoiceEntityCompany.businessRegistrationNumber;
        this.company.sst = this.playerData?.einvoiceEntityCompany.sst;
        this.company.tourismNumber = this.playerData?.einvoiceEntityCompany.tourismNumber;
        this.company.incomeTaxNumber =
          this.playerData?.einvoiceEntityCompany.taxIdentificationNumber;
        this.company.address1 = this.playerData?.einvoiceEntityCompany?.address?.address1;
        this.company.address2 = this.playerData?.einvoiceEntityCompany?.address?.address2;
        this.company.city = this.playerData?.einvoiceEntityCompany?.address?.city;
        this.company.postalCode = this.playerData?.einvoiceEntityCompany?.address?.postCode;
        this.company.state = this.playerData?.einvoiceEntityCompany?.address?.state;
        this.company.country =
          this.playerData?.einvoiceEntityCompany.country?.id ||
          this.playerData?.einvoiceEntityCompany?.address?.countryData?.id;
        this.country =
          this.playerData?.einvoiceEntityCompany.country?.id ||
          this.playerData?.einvoiceEntityCompany?.address?.countryData?.id;
        this.company.phoneNumbers =
          this.playerData?.einvoiceEntityCompany.address?.phoneNumbers?.numbers;
        // this.company = this.playerData?.einvoiceEntityCompany;
      }
    }
  }
}
